// Depends
import { route, meta } from '@/helpers/routes'

import Login from './dweller/form'
import ProfessionalLogin from './professional/form'
import Companylogin from './company/form'

export default [
  route('login', '/dweller/login', Login, meta('Morador Login', false, 'guest', true)),
  route('professional.login', '/professional/login', ProfessionalLogin, meta('Porteiro Login', false, 'guest', true)),
  route('company.login', '/company/login', Companylogin, meta('Adiminstradora Login', false, 'guest', true))
]



// WEBPACK FOOTER //
// ./src/app/auth/login/routes.js